export default {
  list: {
    headers: {
      id: "ID",
      name: "Nazwa zespołu",
    },
    form: {
      name: "Nazwa zespołu",
      id: "id",
    },
  },
};
